export const lst_tipo_afectacion = [
    { id: 1, codigoSunat: "10", nombre: "Gravado - Operación Onerosa" },
    { id: 2, codigoSunat: "11", nombre: "[Gratuita] Gravado – Retiro por premio" },
    { id: 3, codigoSunat: "12", nombre: "[Gratuita] Gravado – Retiro por donación" },
    { id: 4, codigoSunat: "13", nombre: "[Gratuita] Gravado – Retiro" },
    { id: 5, codigoSunat: "14", nombre: "[Gratuita] Gravado – Retiro por publicidad" },
    { id: 6, codigoSunat: "15", nombre: "[Gratuita] Gravado – Bonificaciones" },
    { id: 7, codigoSunat: "16", nombre: "[Gratuita] Gravado – Retiro por entrega a trabajadores" },
    { id: 8, codigoSunat: "20", nombre: "Exonerado - Operación Onerosa" },
    { id: 9, codigoSunat: "30", nombre: "Inafecto - Operación Onerosa" },
    { id: 10, codigoSunat: "31", nombre: "[Gratuita] Inafecto – Retiro por Bonificación" },
    { id: 11, codigoSunat: "32", nombre: "[Gratuita] Inafecto – Retiro" },
    { id: 12, codigoSunat: "33", nombre: "[Gratuita] Inafecto – Retiro por Muestras Médicas" },
    { id: 13, codigoSunat: "34", nombre: "[Gratuita] Inafecto - Retiro por Convenio Colectivo" },
    { id: 14, codigoSunat: "35", nombre: "[Gratuita] Inafecto – Retiro por premio" },
    { id: 15, codigoSunat: "36", nombre: "[Gratuita] Inafecto - Retiro por publicidad" },
    { id: 16, codigoSunat: "40", nombre: "Exportación" },
    { id: 17, codigoSunat: "21", nombre: "[Gratuita] Exonerado - Transferencia gratuita" },
    { id: 18, codigoSunat: "17", nombre: "Gravado - IVAP" },
    { id: 19, codigoSunat: "101", nombre: "[Gratuita] Gravado - IVAP" },
    { id: 20, codigoSunat: "37", nombre: "[Gratuita] Inafecto - Transferencia gratuita" }
]

